/** @param {HTMLFormElement} form */
function initContactForm(form) {
  // Disable the browser's native validation UI so the submit event always
  // fires and this file is the only thing deciding when errors show.
  form.noValidate = true;

  const fields = /** @type {HTMLInputElement[]} */ (Array.from(form.querySelectorAll('[required]')));
  const submitButton = form.querySelector('button[type="submit"]');
  const spinner = form.querySelector('[data-kaw-form-spinner]');

  const resetForm = () => {
    fields.forEach((field) => {
      const errorEl = field.parentElement?.querySelector('[data-kaw-field-error]');
      if (errorEl instanceof HTMLElement) errorEl.hidden = true;
      field.removeAttribute('aria-invalid');
    });
    if (submitButton instanceof HTMLButtonElement) submitButton.disabled = false;
    if (spinner instanceof HTMLElement) spinner.hidden = true;
  };

  // A back/forward-cache restore can bring back a mid-submit DOM state
  // (errors shown, button disabled) without a real reload — clear it.
  resetForm();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) resetForm();
  });

  fields.forEach((field) => {
    field.addEventListener('blur', () => setFieldValidity(field));
  });

  form.addEventListener('submit', (event) => {
    // Block navigation first, unconditionally — only re-submit below once
    // every required field is confirmed valid.
    event.preventDefault();

    fields.forEach((field) => setFieldValidity(field));

    const firstInvalid = fields.find((field) => !field.validity.valid);

    if (firstInvalid) {
      firstInvalid.focus();
      return;
    }

    if (submitButton instanceof HTMLButtonElement) submitButton.disabled = true;
    if (spinner instanceof HTMLElement) spinner.hidden = false;
    form.submit();
  });
}

/** @param {HTMLInputElement} field */
function setFieldValidity(field) {
  const errorEl = field.parentElement?.querySelector('[data-kaw-field-error]');
  if (!(errorEl instanceof HTMLElement)) return;

  const isValid = field.validity.valid;
  errorEl.hidden = isValid;
  field.setAttribute('aria-invalid', String(!isValid));

  if (isValid) return;

  errorEl.innerHTML = field.validity.typeMismatch
    ? 'Please enter a valid email address.<br>Please enter a valid email address (Ex: johndoe@domain.com).'
    : 'This is a required field.';
}

document.querySelectorAll('.kaw-contact-info__form').forEach((form) => {
  if (form instanceof HTMLFormElement) initContactForm(form);
});
